import React from 'react';
import type { ProfessionalLocation } from '@modules/category/type';
import CategoryPageLinkGrid from '@ui-rocco/pages/category-page/CategoryPageLinkGrid';

interface LocationListProps {
    category: string;
    locations: ProfessionalLocation[];
    /**
     * When true the page is a category-less location hub, so links read
     * "Professionals in {place}" rather than "{category} in {place}".
     */
    isHub?: boolean;
    continuesFromPreviousSection?: boolean;
}

/**
 * Category-side node of the location link mesh: surfaces the category × location
 * (or location hub) pages as a curated grid, passing topical anchor-text context.
 */
const CategoryPageLocations = ({
    category,
    locations,
    isHub = false,
    continuesFromPreviousSection = false,
}: LocationListProps) => {
    const heading = isHub
        ? 'Browse professionals by location'
        : `Browse ${category} by location`;

    const items = locations.map((location) => ({
        key: location.ID,
        href: location.Link,
        label: isHub
            ? `Professionals in ${location.Title}`
            : `${category} in ${location.Title}`,
    }));

    return (
        <CategoryPageLinkGrid
            heading={heading}
            items={items}
            continuesFromPreviousSection={continuesFromPreviousSection}
        />
    );
};

export default CategoryPageLocations;
